module.exports = __webpack_public_path__ + "static/img/759.486d5a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/rjzz/759.jpg
// module id = nErA
// module chunks = 0